export default __webpack_public_path__ + "static/media/home-decor-2.b4e5397c.jpg";